import FAQSection from './FAQSection';
import ContactSection from './ContactSection';
import AboutIIMJobsSection from './AboutIIMJobsSection';
import PartnerCompaniesSection from './PartnerCompaniesSection';
import EligibilitySection from './EligibilitySection';
import HomeNavigation from './HomeNavigation';
import AboutCompetitionSection from './AboutCompetitionSection';
import CompetitionBanner from './CompetitionBanner';
import RewardSection from './RewardSection';
import RoundAndTimelineSection from './RoundAndTimelineSection';
import HeroPartnerSection from './HeroPartnerCompanies';
import EpochTerms from './EpochTerms';
import ParticipationBanner from './ParticipationBanner';
import EpochWinners from './EpochWinners';

export {
  RewardSection,
  HomeNavigation,
  PartnerCompaniesSection,
  EligibilitySection,
  ContactSection,
  FAQSection,
  AboutIIMJobsSection,
  AboutCompetitionSection,
  RoundAndTimelineSection,
  CompetitionBanner,
  HeroPartnerSection,
  EpochTerms,
  ParticipationBanner,
  EpochWinners,
};
